export default __webpack_public_path__ + "static/media/236.2ed9039b.png";